import { MessageState } from 'types/message';

export function getHasConversation(messageState: MessageState): boolean {
  return !!messageState?.conversationId;
}
